module.exports = __webpack_public_path__ + "media/images/showbg-1a55d5e46143a358a1121c835c2810b7.png";